import { useStore } from "@/stores/store";
import { ISearchResultItem } from "interfaces/search/ISearchResultItem";
import Fuse from "fuse.js";
import { useUtil } from "./util-service";

export const useSearch = () => {
  const generalStore = useStore()
  const { stringSort } = useUtil();

  const getUniqueValues = (dataKeys: string | string[]): string[] => {
    // Ensure dataKeys is always an array
    const keys = Array.isArray(dataKeys)
      ? dataKeys
      : [dataKeys];
    const set = new Set<string>();

    generalStore.originalSearchResult?.results.forEach((item: ISearchResultItem) => {
      keys.forEach(key => {
        const columnValue = (item as any)[key];
        // If the value is a string, just add it, array? Add each of the string in the array
        if (typeof columnValue === 'string') {
          set.add(columnValue);
        }
        else if (Array.isArray(columnValue)) {
          columnValue.forEach(str => {
            if (typeof str === 'string') {
              set.add(str)
            };
          });
        }
      });
    });

        return Array.from(set).sort((a, b) => stringSort(a, b));
  }


  const performSearch = (query: string) => {
    if (generalStore.searchResult) {
      const columnsWithMatches = new Set();
      let filteredResults = [];

        const options = {
          includeScore: true,
          threshold: 0.25,
          minMatchCharLength: 3,
          includeMatches: true, // Include detailed matches
          keys: ['type', 'name', 'alternateNames', 'fates', 'woodType']
        };
        const fuse = new Fuse(generalStore.searchResult.results, options);
        const fuzzyMatches = fuse.search(query);
        filteredResults = fuzzyMatches.map(match => match.item);
        const matches = {}; // Object to generalStore match details for each item
        
        fuzzyMatches.forEach(match => {
          // Storing match details for the specific item based on its ID
          matches[match.item.id] = match.matches.map(m => ({
            key: m.key,
            indices: m.indices
          }));

          // Also updating columnsWithMatches Set with the keys of matched fields
          if (match.matches) {
            match.matches.forEach(matchDetail => {
              columnsWithMatches.add(matchDetail.key);
            });
          }
        });

        generalStore.searchMatches = matches;


      const updatedSearchResult = {
        ...generalStore.searchResult,
        results: filteredResults
      };

      generalStore.searchResult = updatedSearchResult;
      generalStore.currentPage = 0;
    }
  };

  const sortSearchResult = (key: string, isAscending: boolean) => {
    if (generalStore.searchResult && generalStore.searchResult.results && generalStore.searchResult.results.length > 0) {
      const sortedResults = [...generalStore.searchResult.results];      
      // Check the data type of the key in the first object of the array
      if (typeof sortedResults[0][key] === 'number' || key == 'launchDate' || key == 'suspension') {
        sortedResults.sort((a, b) => isAscending ? b[key] - a[key] : a[key] - b[key]);
      } else {
        sortedResults.sort((a, b) => {
          // Handle possible null or undefined values
          const aValue = String(a[key] || '');
          const bValue = String(b[key] || '');

          return stringSort(aValue, bValue, isAscending);
        });
      }

      generalStore.searchResult = { ...generalStore.searchResult, results: sortedResults };
    }
  } 

  return {
    getUniqueValues,
    performSearch,
    sortSearchResult
  }
}